import 'scroll-depth';

$(document).ready(() => {
  $.scrollDepth({
    minHeight: 2000,
    percentage: true,
    userTiming: false,
    pixelDepth: false,
    nonInteraction: false,
    eventHandler: data => logActivity(data),
  });
});

function logActivity(data) {
  if (!window.ga) { return; }

  if (!window.gtag) { return; }

  window.gtag('event', 'Scroll', {
    event_category: 'Scroll',
    event_label: 'Scroll Depth',
    value: parseInt(data.eventLabel, 10),
  });
}
